import React from 'react';
import { useHistory } from 'react-router-dom';
import { CentsDataGridServer } from 'components/common/dataGrid/dataGridServer';
import TableSearchBar from 'components/common/search/TableSearchBar';
import { usePaginatedTableQuery } from 'hooks/usePaginatedTableQuery';
import { getCentsCustomers } from 'api/admin/customers/customers';

const COLUMNS = [
  { headerName: 'ID', field: 'id', flex: 0.5 },
  { headerName: 'First Name', field: 'firstName', flex: 1 },
  { headerName: 'Last Name', field: 'lastName', flex: 1 },
  { headerName: 'Email', field: 'email', flex: 1 },
  { headerName: 'Phone Number', field: 'phoneNumber', flex: 1 },
  { headerName: 'Stripe Customer ID', field: 'stripeCustomerId', flex: 1 },
  { headerName: 'Created At', field: 'createdAt', flex: 1 },
];

const CentsCustomersTable = () => {
  const history = useHistory();
  const {
    data,
    isLoading,
    pageNumber,
    pageSize,
    searchInput,
    handleSearch,
    sortModel,
    handleSortModelChange,
    handlePageChange,
  } = usePaginatedTableQuery({
    queryKey: 'searchCustomers',
    queryFn: async ({ searchInput, pageNumber, pageSize, sortBy, sortOrder }) => {
      const { data } = await getCentsCustomers(
        pageNumber,
        searchInput,
        pageSize,
        sortBy,
        sortOrder,
      );
      return {
        centsCustomers: data.customers,
        centsCustomerCount: data.total,
      };
    },
    errorMessage: 'Failed to load customers. Showing last loaded results.',
  });
  const { centsCustomers, centsCustomerCount } = data ?? {};

  const handleRowClick = ({ id }) => {
    history.push(`/customers/${Number(id)}`);
  };

  const handleUploadCustomersClick = () => {
    history.push(`/customers/upload`);
  };

  const handleDeleteOrRestoreUploadClick = () => {
    history.push(`/customers/delete-restore-upload`);
  };

  const hanldeCSVDataEditorClick = () => {
    history.push(`/customers/csvdataeditor`);
  };

  return (
    <div className="page-container">
      <div className="cents-customers-header">
        <h1>Customers</h1>
        <div className="cents-customers-header-buttons">
          <button className="csv-data-editor-button" onClick={hanldeCSVDataEditorClick}>
            CSV Data Editor
          </button>
          <button className="create-cents-customer-button" onClick={handleUploadCustomersClick}>
            Upload Customer List
          </button>
          <button
            className="create-cents-customer-button"
            onClick={handleDeleteOrRestoreUploadClick}
          >
            Bulk Delete/Restore Customers
          </button>
        </div>
      </div>
      <div className="customer-search-bar">
        <TableSearchBar
          value={searchInput}
          placeholder="Find a Cents customer"
          onSearch={handleSearch}
        />
      </div>
      <CentsDataGridServer
        tableName="CUSTOMERS"
        columns={COLUMNS}
        data={centsCustomers ?? []}
        rowCount={centsCustomerCount ?? 0}
        pageSize={pageSize}
        page={pageNumber}
        onPageChange={handlePageChange}
        onRowClick={handleRowClick}
        isLoading={isLoading}
        sortModel={sortModel}
        onSortModelChange={handleSortModelChange}
      />
    </div>
  );
};

export default CentsCustomersTable;
